export const CODE_STATE_ITALIAN = '100';
